/**
 * Enum кодов для кастомизации функционала и интерфейса проекта. См класс @Customization
 */
export enum CodeEnum {
  /**
   * Добавление организации в профиле пользователя
   */
  ADD_ORG = 'add-org',
  /**
   * Удаление организации в профиле пользователя
   */
  DEL_ORG = 'del-org',
  /**
   * Редактирование организации в профиле пользователя
   */
  EDIT_ORG = 'edit-org',
  /**
   * Добавления документа в профиле пользователя
   */
  ADD_DOC = 'add-doc',
  /**
   * Удаления документа в профиле пользователя
   */
  DEL_DOC = 'del-doc',
  /**
   * Отображать раздел Документы в профиле пользователя
   */
  DOC = 'doc',
  /**
   * Отображать раздел Транспорт в профиле пользователя
   */
  VEHICLES = 'vehicles',
  /**
   * Отображать раздел Транспорт в профиле иностранного пользователя
   */
  FOREIGN_VEHICLES = 'foreign-vehicles',
  /**
   * Отображать страницу Срок действия ссылки на активацию учетной записи истек
   */
  MAIL_EXPIRED = 'mail-expired',
  /**
   * Отображать страницу Регистрации специалиста
   */
  REG_SPECIALIST = 'reg-specialist',
  /**
   * Отображать страницу Регистрации иностранца/русского
   */
  REG_FOREIGN = 'reg-foreign',
  /**
   * Отображать страницу информационного окна 'Аккаунт создан', которая открывается после успешной регистрации
   */
  REG_SUCCESS = 'reg-success',
  /**
   * Отображать страницу 'Восстановление пароля'
   */
  RESTORE_PWD = 'restore-pwd',
  /**
   * Отображать страницу 'Ссылка на восстановление пароля устарела'
   */
  RESTORE_PWD_EXPIRED = 'restore-pwd-expired',
  /**
   * Подтверждение иностранца проводить локально в админке, а не через очереди с внешней интеграцией
   */
  FOREIGN_LOCAL = 'foreign-local',
  /**
   * Включать раздел 'Персональных данных' у Иностранной организации
   */
  FOREIGN_ORG_PERSONAL = 'foreign-org-personal',
  /**
   * Включать 'Налоговый номер'(ИНН) у Иностранной организации
   */
  FOREIGN_ORG_INN = 'foreign-org-inn',
  /**
   * Включать 'Налоговый номер'(ИНН) у Иностранной организации
   */
  FOREIGN_PERSONAL_INN = 'foreign-personal-inn',
  /**
   * Включать 'Руководитель'(Признак первого лица) у Иностранной организации
   */
  FOREIGN_ORG_CHIEF = 'foreign-org-chief',
  /**
   * Включать "Код налогового органа" у Иностранной организации и иностранного пользователя
   */
  FOREIGN_TAX_AUTHORITY = 'foreign-code-tax-authority',
  /**
   * Включать обязательную активацию телефона
   */
  NEED_CONFIRM_PHONE = 'need-confirm-phone',
  /**
   * FlashCall. Время жизни сессии, в течении которого можно позвонить пока телефон не устарел(по умолчанию 120 секунд)
   */
  FLASHCALL_EXPIRE_SECONDS = 'flashcall-expire-seconds',
  /**
   * Тема. Возможные варианты темы: blue или grey
   */
  THEME = 'theme',
  /**
   * Пропускать на ИС неподтвержденных пользователей
   */
  SIGNIN_UNTRUSTED_USERS_OAUTH = 'signin-untrusted-users-oauth',
  /**
   * Капча. Время жизни маркера доступа, для капчи, в минутах
   */
  CAPTCHA_TEST_TOKEN_EXPIRE_MINUTES = 'captcha-test-token-expire-minutes',
  /**
   * Проверка электронной почты на русский домен
   */
  EMAIL_CHECK_RU_DOMAIN = 'email-check-ru-domain',
  /**
   * Количество ретраев на получение данных с госуслуг
   */
  ESIA_RETRY_COUNT = 'esia-retry-count',
  /**
   * Отображать колонку Кто изменил в профиле в окне История изменения статуса
   */
  STATUS_HISTORY_EDITED_BY = 'status-history-edited-by',
  /**
   * отображать страницу 'Ввода нового пароля' после подтверждения через почту
   */
  CONFIRM_PWD = 'confirm-pwd',
  RESTORE_PWD_LINK = 'restore-pwd-link',
  /**
   * Если задана эта опция(ссылка на файл с инструкцикией), то на странице "нет прав" отображать ссылку
   */
  NORIGHTS_INSTRUCTION_HREF = 'norights-instruction-href',
  /** IP блокировка. Количество раз неправильного ввода пароля, после которого используются механизмы ввода проверочного кода (CAPTCHA) */
  PASSWORD_WRONG_COUNT_IP = 'password-wrong-count-ip',
  /** IP блокировка. Сколько раз можно некорректно ввести капчу/пароль до блокировки по ip (при авторизации) */
  CAPTCHA_WRONG_COUNT_IP = 'captcha-wrong-count-ip',

  // Включена ли функциональность для работы с адресом регистрации пользователя
  IS_ADDRESS_FUNCTIONALITY_ENABLED = 'is-address-functionality-enabled',

  // Включена ли функциональность для работы с паспортом пользователя
  IS_ID_DOC_FUNCTIONALITY_ENABLED = 'is-id-doc-functionality-enabled',

  // Включена ли функциональность для работы с автотранспортом пользователя
  IS_VEHICLE_FUNCTIONALITY_ENABLED = 'is-vehicle-functionality-enabled',

  // Включена ли функциональность для работы с автотранспортом организации пользователя
  IS_ORG_VEHICLE_FUNCTIONALITY_ENABLED = 'is-org-vehicle-functionality-enabled',

  // Пропускать на ИС(давать аунтифицироваться по oauth) организации только успешно прошедшие проверку в ЕГРЮЛ/ЕГРИП
  SIGIN_ONLY_VERIFIED_ORG = 'sigin-only-verified-org',
}
